import { confirmDelete, getData } from "../helpers";

const load = (element) => {
    // console.log(element);

    element.addEventListener("click", () => {
        confirmDelete(
            getData(element, "title"),
            getData(element, "data-text"),
            getData(element, "data-url"),
            getData(element, "data-accounted"),
            getData(element, "data-cancel")
        );
    });
};

class AccountedButton extends HTMLButtonElement {
    connectedCallback() {
        load(this);
    }
}

window.customElements.define("accounted-button", AccountedButton, {
    extends: "button",
});
